import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=2a231c64&"
import script from "./Interaction.vue?vue&type=script&lang=js&"
export * from "./Interaction.vue?vue&type=script&lang=js&"
import style0 from "./Interaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports